/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox, FilledButton, Popover, Typography } from '@neo4j-ndl/react';

const options = [
  { label: 'Neo4j', value: 'neo4j' },
  { label: 'Aura', value: 'aura' },
  { label: 'Bloom', value: 'bloom' },
  { label: 'Data Importer', value: 'data-importer' },
  { label: 'GraphQL Library', value: 'graphql-library' },
  { label: 'Cypher', value: 'cypher' },
];

const Component = () => (
  <Popover isPortaled>
    <Popover.Trigger hasButtonWrapper>
      <FilledButton>Open popover</FilledButton>
    </Popover.Trigger>
    <Popover.Content className="n-max-h-[240px] n-w-[400px] n-overflow-y-auto n-p-token-16">
      <div className="n-flex n-flex-col n-gap-token-16">
        <Typography variant="body-medium">
          Scroll this popover while the combobox panel is open to verify that it
          remains anchored and is not clipped by the overflow container.
        </Typography>
        <div className="n-h-[120px] n-shrink-0 n-rounded-sm n-border n-border-neutral-border-strong n-bg-neutral-bg-weak" />
        <Combobox
          label="Product"
          helpText="The combobox panel is independently portaled above this popover."
          isFluid
          options={options}
          searchPlaceholder="Search products"
        />
        <div className="n-h-[120px] n-shrink-0 n-rounded-sm n-border n-border-neutral-border-strong n-bg-neutral-bg-weak" />
      </div>
    </Popover.Content>
  </Popover>
);

export default Component;
